$(document).ready(function(){function e(){50<=$(window).scrollTop()?$("#shopify-section-header").addClass("sticky"):$("#shopify-section-header").removeClass("sticky")}e(),$(window).scroll(e),$(".section-collection-list .collection-list").slick({autoplay:!1,autoplaySpeed:2500,speed:800,cssEase:"linear",arrows:!1,slidesToShow:3,slidesToScroll:1,dots:!1,infinite:!0,useTransform:!0,responsive:[{breakpoint:991,settings:{arrows:!1}},{breakpoint:767,settings:{slidesToShow:2}},{breakpoint:575,settings:{slidesToShow:1}}]}),$(".card-wrapper ").each(function(){var e=`<a href="${$(this).find(".card__heading a").attr("href")}">Read More</a>`,a=$(this).find(".article-card__info");$(a).append(e)});var a=$("section#shopify-section-template--23131232403744__1e2c7ab6-59af-48f0-8772-a0f20ca71a85 .title-wrapper-with-link");$(a).addClass("site_wrap rec_blo_head"),$(a).find(".blog__title").addClass("site_h2");let s=$('.account .acc_or_table tr td[data-label="Fulfillment status"] span');$(s).each(function(){console.log(s.text()),"pending"==$(s).text().toString()?$(s).addClass("pendi"):"Unfulfilled"==$(s).text().toString()?$(s).addClass("unfil"):"Fulfilled"==$(s).text().toString()&&$(s).addClass("fulfil")}),$("summary.mobile-facets__open-wrapper,summary.header__icon.header__icon--menu.header__icon--summary").click(function(){console.log("hh"),$("body").hasClass("overflow-hidden-tablet")||$("body").hasClass("overflow-hidden-mobile")?$("html").addClass("make_hi"):$("html").removeClass("make_hi")})});




     $('.banner-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  // autoplay: true,
  // autoplaySpeed: 5000,
  arrows: false,
  dots: true,
  
});
$('.feature-collection-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  dots: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  
});
$('.collection-slider_home').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  loop: true,
  autoplaySpeed: 4000,
  arrows: false,
  dots: false,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        var loaderMask = document.querySelector('.loader-mask');
        if (loaderMask) {
            loaderMask.classList.add('active');
        }
    }, 1000);
});


$(document).ready(function(){
  $(".tab-01").click(function(){
    $(".product-tab-ans-01, .tab-01").addClass("active");
   $(".product-tab-ans-02, .tab-02").removeClass("active");
  });
  $(".tab-02").click(function(){
    $(".product-tab-ans-01, .tab-01").removeClass("active");
     $(".product-tab-ans-02, .tab-02").addClass("active");
  });
});


$(document).ready(function() {
    $(".footer-block__heading").click(function() {
        $(this).next(".footer-block__details-content").toggleClass("active");
    });
    $(".footer-block__heading").click(function() {
        $(".cd_contact-company").toggleClass("active");
    });
});

// document.addEventListener("DOMContentLoaded", function() {
//     // Get the radio buttons for Size
//     const sizeRadioPack3 = document.getElementById('template--23656242151712__main-1-1');
//     const sizeRadioPack8 = document.getElementById('template--23656242151712__main-1-0');
//     const sizeRadioPack2 = document.getElementById('template--23656242151712__main-1-2');

//     // Get all the fragrance radio buttons and their labels
//     const fragrances = document.querySelectorAll('input[name="fragrances Type"]');
//     const fragranceLabels = document.querySelectorAll('label[for^="fragrance"]'); // Select labels for fragrance inputs
    
//     // Fragrances for each pack
//     const fragrancesForPack3 = [
//         'Martin', 
//         'Jaipur and royal oud', 
//         'rose', 
//         'jasmine and frangipani', 
//         'royal oud', 
//         'winsome & zephyr'
//     ];

//     const fragrancesForPack2 = [
//         'Martin & Jaipur', 
//         'rose & jasmine', 
//         'royal oud & frangipani', 
//         'winsome & zephyr'
//     ];

//     const fragrancesForPack8 = [
//         'all fragrances'
//     ];

//     // Function to toggle active class based on selected size
//     function toggleActiveClass() {
//         // Clear the active class from all fragrances and labels
//         fragrances.forEach(function(fragrance) {
//             // Remove active class from the fragrance input
//             fragrance.classList.remove('active'); 

//             // Also remove active class from its corresponding label
//             const correspondingLabel = document.querySelector(`label[for="${fragrance.id}"]`);
//             if (correspondingLabel) {
//                 correspondingLabel.classList.remove('active'); // Remove active class from the label
//                 console.log(`Removed active from label for ${fragrance.value}:`, !correspondingLabel.classList.contains('active'));
//             }
//         });

//         // Check the selected pack size and add active class to matching fragrances and labels
//         if (sizeRadioPack8.checked) {
//             fragrances.forEach(function(fragrance) {
//                 if (fragrancesForPack8.includes(fragrance.value)) {
//                     fragrance.classList.add('active'); // Add active class to matching fragrance
//                     const correspondingLabel = document.querySelector(`label[for="${fragrance.id}"]`);
//                     if (correspondingLabel) {
//                         correspondingLabel.classList.add('active'); // Add active class to corresponding label
//                         console.log(`Added active to label for ${fragrance.value}`);
//                     }
//                 }
//             });
//         } else if (sizeRadioPack3.checked) {
//             fragrances.forEach(function(fragrance) {
//                 if (fragrancesForPack3.includes(fragrance.value)) {
//                     fragrance.classList.add('active'); // Add active class to matching fragrance
//                     const correspondingLabel = document.querySelector(`label[for="${fragrance.id}"]`);
//                     if (correspondingLabel) {
//                         correspondingLabel.classList.add('active'); // Add active class to corresponding label
//                         console.log(`Added active to label for ${fragrance.value}`);
//                     }
//                 }
//             });
//         } else if (sizeRadioPack2.checked) {
//             fragrances.forEach(function(fragrance) {
//                 if (fragrancesForPack2.includes(fragrance.value)) {
//                     fragrance.classList.add('active'); // Add active class to matching fragrance
//                     const correspondingLabel = document.querySelector(`label[for="${fragrance.id}"]`);
//                     if (correspondingLabel) {
//                         correspondingLabel.classList.add('active'); // Add active class to corresponding label
//                         console.log(`Added active to label for ${fragrance.value}`);
//                     }
//                 }
//             });
//         }
//     }

//     // Set initial selection and add event listeners
//     sizeRadioPack8.checked = true; // Default checked size
//     toggleActiveClass(); // Initialize active classes on load

//     // Event listeners for Size radio buttons
//     sizeRadioPack3.addEventListener('change', toggleActiveClass);
//     sizeRadioPack8.addEventListener('change', toggleActiveClass);
//     sizeRadioPack2.addEventListener('change', toggleActiveClass);
// });




















